import React from "react";

import { CaseTemplateDropdown } from "src/cases/common/CaseTemplateDropdown";
import { useCaseTemplatesForWorkspace } from "src/cases/queries/templates";

type TemplateSelection = {
  templateId: string;
  versionId: string;
};

type WorkspaceTemplateSelectorProps = {
  error?: boolean;
  value: TemplateSelection;
  workspaceBaseUrl: string | undefined;
  onChange: (value: TemplateSelection) => void;
  authToken?: string;
  isSourcePending?: boolean;
  isSourceError?: boolean;
};

export const WorkspaceTemplateSelector: React.FC<
  WorkspaceTemplateSelectorProps
> = ({
  error,
  value,
  workspaceBaseUrl,
  onChange,
  authToken,
  isSourcePending = false,
  isSourceError = false,
}) => {
  const { data: templates = [], isLoading: isLoadingTemplates } =
    useCaseTemplatesForWorkspace(workspaceBaseUrl, {
      enabled: !!workspaceBaseUrl && !isSourcePending && !isSourceError,
      authToken,
    });

  const isLoading = isLoadingTemplates || isSourcePending;

  const getPlaceholder = () => {
    if (!workspaceBaseUrl) {
      return "Select workspace first";
    }
    if (isSourceError) {
      return "Couldn't load templates";
    }
    if (!isLoading && templates.length === 0) {
      return "No templates available";
    }
    return "Select template and version";
  };

  const isDisabled =
    !workspaceBaseUrl || isLoading || isSourceError || templates.length === 0;

  return (
    <CaseTemplateDropdown
      className="w-full"
      dataLoc="create-from-existing-template-selector"
      disabled={isDisabled}
      error={error || isSourceError}
      options={templates}
      placeholder={getPlaceholder()}
      selected={value.templateId && value.versionId ? value : undefined}
      onSelect={onChange}
    />
  );
};
